export default "__VITE_ASSET__89803957__"